import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AccountManagerService from '../../../../services/Celcoin/accountManagerService';
import { useState, useEffect } from 'react';
import { getTranslations } from '../../../../services/languageUtils';
import CashOutService from '../../../../services/Celcoin/dinamicCashOutService';

export default function TransferTypeBatch() {
  const [translations, setTranslations] = useState({});
  const [file, setFile] = useState(null);
  const [pinCode, setPinCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [colors, setColors] = useState({ primary: '#1c787e', secondary: '#061B2B' });
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [transferPending, setTransferPending] = useState(false);
  const [twoFactorCode, setTwoFactorCode] = useState('');

  const selectColors = (theme) => {
    const themes = {
      zicredit: {
        primary: "#FFCC00",
        secondary: "#061B2B"
      },
      default: {
        primary: "#1c787e",
        secondary: "#061B2B"
      }
    };
    return themes[theme] || themes.default;
  };

  const verifyDomain = (domain) => {
    const hostname = window.location.hostname;
    return hostname.includes(domain);
  };

  useEffect(() => {
    if (verifyDomain("zicredit.com")) {
      setColors(selectColors("zicredit"));
    } else {
      setColors(selectColors("default"));
    }

    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSendClick = () => {
    if (!file) {
      alert("Por favor, selecione um arquivo.");
      return;
    }
    setShow2FAModal(true);
    setTransferPending(true);
  };

  const confirmTransfer = async () => {
    if (!file) return;

    setLoading(true);
    try {
      await CashOutService.sendBatchPaymentsTed(file);
      alert("Arquivo enviado com sucesso!");
    } catch (error) {
      console.error("Erro ao enviar o arquivo:", error);
      alert("Erro ao enviar o arquivo.");
    } finally {
      setLoading(false);
      setShow2FAModal(false);
      setTransferPending(false);
    }
  };

  const handleDownloadExample = () => {
    const link = document.createElement('a');
    link.href = '/assets/files/exampleted.xlsx';
    link.download = 'example.xlsx';
    link.click();
  };

  return (
    <section id="pixTransferComponent" className="pixTransferComponent">
      <div>
        <div className="mainContent100" style={{ maxWidth: '600px' }}>
          <input
            type="file"
            className="input"
            onChange={handleFileChange}
          />

          <div
            className="buttonSend"
            onClick={handleSendClick}
            style={{
              backgroundColor: colors.primary,
              color: "#fff",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
              textAlign: "center",
              cursor: "pointer"
            }}
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </div>

          <div
            className="buttonSend"
            onClick={handleDownloadExample}
            style={{
              backgroundColor: "#fff",
              color: colors.primary,
              border: `1px solid ${colors.primary}`,
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
              textAlign: "center",
              cursor: "pointer"
            }}
          >
            {'Modelo de arquivo'}
          </div>
        </div>
      </div>

      {show2FAModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "24px",
              minWidth: "350px",
              maxWidth: "90%",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
              {translations.twoFactorAuthentication || 'Autenticação de Dois Fatores'}
            </h3>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
              {translations.enterCodeFromApp || 'Digite o código de 6 dígitos do seu aplicativo autenticador:'}
            </p>

            <input
              type="text"
              value={twoFactorCode}
              onChange={(e) => setTwoFactorCode(e.target.value)}
              maxLength="6"
              placeholder="000000"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                fontSize: "18px",
                textAlign: "center",
                letterSpacing: "4px",
                border: "2px solid #ddd",
                borderRadius: "6px",
                margin: "16px 0",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "20px" }}>
              <button
                onClick={() => setShow2FAModal(false)}
                disabled={loading}
                style={{
                  backgroundColor: "white",
                  border: "1px solid #aaa",
                  color: "#555",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {translations.cancel || 'Cancelar'}
              </button>
              <button
                onClick={confirmTransfer}
                disabled={loading || twoFactorCode.length !== 6}
                style={{
                  backgroundColor: loading || twoFactorCode.length !== 6 ? "#ccc" : colors.primary,
                  border: "none",
                  color: "white",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  cursor: loading || twoFactorCode.length !== 6 ? "not-allowed" : "pointer",
                  fontWeight: "bold",
                }}
              >
                {loading ? (translations.verifying || 'Verificando...') : (translations.verify || 'Confirmar')}
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </section>
  );
}
